export const convertStringToNumber = (betrag, def) => {
    if (betrag === undefined || betrag === null || betrag === '') {
        return def
    }
    const number = +betrag
    if (isNaN(number)) {
        return def
    }
    return Math.round(number * 100)/100
}
export const convertParameterToNumber = (stringNumber) => stringNumber && Number.parseInt(stringNumber)